import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Info } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-muted text-muted-foreground py-8 mt-12 border-t">
      <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-6 text-center md:text-left">
        <div className="text-sm">
          <p>&copy; {currentYear} CylostreamWeb. Alle rechten voorbehouden.</p>
          <p className="text-xs mt-1">
            Bekijk ook onze <a href="/original/" rel="noopener noreferrer" className="hover:text-primary underline">AI Automatisatie Diensten</a>.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 text-xs justify-center">
           <div className="flex items-center justify-center sm:justify-start space-x-1.5">
            <Mail size={14} className="text-primary" />
            <a href="mailto:contact@cylostream.com" className="hover:text-primary transition-colors">contact@cylostream.com</a>
          </div>
           <div className="flex items-center justify-center sm:justify-start space-x-1.5">
            <Phone size={14} className="text-primary" />
            <a href="tel:+32468110615" className="hover:text-primary transition-colors">+32 468 11 06 15</a>
          </div>
           <div className="flex items-center justify-center sm:justify-start space-x-1.5">
            <Info size={14} className="text-primary" />
            <span>BE1022.402.368</span>
          </div>
        </div>

        <div className="flex space-x-4 text-sm">
          <Link to="/privacy" className="hover:text-primary">Privacybeleid</Link>
          <span className="opacity-50">|</span>
          <Link to="/terms" className="hover:text-primary">Algemene Voorwaarden</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
